import r from "./_indexOf.mjs";
function f(e, n) {
  return r(n, e, 0) >= 0;
}
export {
  f as default
};
